import { render } from "./new.vue?vue&type=template&id=591b39f9"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=591b39f9&lang=css"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__